import { Routes } from '@angular/router';
import 'hammerjs';
import { TitleMode } from './ui/title-mode';
import { AccentuatedMode } from './ui/accentuated-mode';
import { HomePageComponent } from './home-page/home-page.component';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { ProjectPageComponent } from './project-page/project-page.component';
import { NewsPageComponent } from './news-page/news-page.component';
import { NewsItemPageComponent } from './news-item-page/news-item-page.component';
import { ProjectsPageComponent } from './projects-page/projects-page.component';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { ZevensterPageComponent } from './zevenster-page/zevenster-page.component';
import { ZevensterCertificatePageComponent } from './zevenster-certificate-page/zevenster-certificate-page.component';
import { ZevensterPurchasePageComponent } from './zevenster-purchase-page/zevenster-purchase-page.component';
import { ZevensterCheckoutPageComponent } from './zevenster-checkout-page/zevenster-checkout-page.component';
import { CommonPageComponent } from './common-page/common-page.component';
import { EventsPageComponent } from './events-page/events-page.component';
import { AdminPageComponent } from './admin-page/admin-page.component';
import { AdminPurchasePageComponent } from './admin-purchase-page/admin-purchase-page.component';
var ɵ0 = { accentuatedMode: AccentuatedMode.White }, ɵ1 = { titleMode: TitleMode.Dynamic }, ɵ2 = { titleMode: TitleMode.Static, title: 'Nieuws' }, ɵ3 = { titleMode: TitleMode.Static, title: 'Visie' }, ɵ4 = { titleMode: TitleMode.Static, title: 'Zevensterbos' }, ɵ5 = { titleMode: TitleMode.Dynamic }, ɵ6 = { titleMode: TitleMode.Static, title: 'Contact' }, ɵ7 = { titleMode: TitleMode.Static, title: 'Certificaat' }, ɵ8 = { titleMode: TitleMode.Static, title: 'Bijdrage' }, ɵ9 = { titleMode: TitleMode.Static, title: 'Bijdrage' }, ɵ10 = { titleMode: TitleMode.Static, title: 'Evenementen' }, ɵ11 = { titleMode: TitleMode.Static, title: 'Admin' }, ɵ12 = { titleMode: TitleMode.Static, title: 'Admin / bijdrage' }, ɵ13 = { titleMode: TitleMode.Static, title: 'Admin / bijdrage' };
var routes = [
    { path: '', component: HomePageComponent },
    { path: 'projecten', component: ProjectsPageComponent, data: ɵ0 },
    { path: 'projecten/:project_uid', component: ProjectPageComponent, data: ɵ1 },
    { path: 'news', component: NewsPageComponent, data: ɵ2 },
    { path: 'visie-en-missie', component: CommonPageComponent, data: ɵ3 },
    { path: 'zevensterbos', component: ZevensterPageComponent, data: ɵ4 },
    { path: 'news/:news_item_uid', component: NewsItemPageComponent, data: ɵ5 },
    { path: 'contact', component: ContactPageComponent, data: ɵ6 },
    { path: 'zevensterbos/certificaten/:purchase_uid', component: ZevensterCertificatePageComponent, data: ɵ7 },
    { path: 'zevensterbos/bijdrages/:purchase_access_code', component: ZevensterPurchasePageComponent, data: ɵ8 },
    { path: 'zevensterbos/checkout', component: ZevensterCheckoutPageComponent, data: ɵ9 },
    { path: 'evenementen', component: EventsPageComponent, data: ɵ10 },
    { path: 'admin', component: AdminPageComponent, data: ɵ11 },
    { path: 'admin/bijdrages/nieuw', component: AdminPurchasePageComponent, data: ɵ12 },
    { path: 'admin/bijdrages/:purchase_uid', component: AdminPurchasePageComponent, data: ɵ13 },
    { path: '**', component: NotFoundPageComponent }
];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13 };
//# sourceMappingURL=app.module.js.map